import { emsMediumGrey } from "@electricMotorShop/EmsVariables";
import { cardContainerStyles } from "@insite/content-library/Components/CardContainer";
import { cardContainerMultiColumnStyles } from "@insite/content-library/Components/CardContainerMultiColumn";
import { productDescriptionStyles } from "@insite/content-library/Components/ProductDescription";
import { productPrimaryImageStyles } from "@insite/content-library/Components/ProductPrimaryImage";
import { addToListLinkStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsAddToListLink";
import { pageTitleStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsPageTitle";
import { shareLinkStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsShareLink";
import { actionsStyles } from "@insite/content-library/Widgets/ProductList/ProductListActions";
import { listStyles } from "@insite/content-library/Widgets/ProductList/ProductListCardList";
import { columnsStyles } from "@insite/content-library/Widgets/ProductList/ProductListColumns";
import { productCardStyles } from "@insite/content-library/Widgets/ProductList/ProductListProductCard";
import { productCountStyles } from "@insite/content-library/Widgets/ProductList/ProductListProductCount";
import { productGridCardStyles } from "@insite/content-library/Widgets/ProductList/ProductListProductGridCard";
import { productImageStyles } from "@insite/content-library/Widgets/ProductList/ProductListProductImage";
import { viewSelectStyles } from "@insite/content-library/Widgets/ProductList/ProductListTableViewFilter";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { css } from "styled-components";

// ProductDetailsPageTitle
pageTitleStyles.titleText = {
    variant: "h1",
    css: css`
        font-size: 32px;
        line-height: 1.2;
        margin-bottom: 10px;
    `,
};

// ProductPrimaryImage
productPrimaryImageStyles.centeringWrapper = {
    css: css`
        min-height: 300px;
        margin: 10px 0;
        display: flex;
        align-items: center;
        justify-content: center;
        img,
        .sirv-spin-container {
            height: auto;
            max-width: 100%;
            max-height: 550px;
        }
    `,
};

// ProductDetailsAddToListLink
addToListLinkStyles.wrapper = {
    css: css`
        margin-top: 0px;
        text-align: center;
    `,
};

// ProductDetailsShareLink
shareLinkStyles.wrapper = {
    css: css`
        margin-top: 0px;
        text-align: center;
    `,
};

// PLP

// ProductListProductCount
productCountStyles.wrapper = {
    css: css`
        margin: 0 16px;
    `,
};

productCountStyles.countText = {
    css: css`
        white-space: nowrap;
        font-weight: bold;
    `,
};

productCountStyles.itemsText = {
    css: css`
        font-weight: bold;
    `,
};

// ProductListColumns
columnsStyles.container = {
    gap: 0,
    css: css`
        ${({ theme }) =>
            breakpointMediaQueries(
                theme,
                [
                    null,
                    null,
                    css`
                        margin: 0;
                    `,
                ],
                "max",
            )}
    `,
};

columnsStyles.leftColumnGridItem = {
    width: [0, 0, 3, 3, 3],
    css: css`
        padding-right: 36px;
    `,
};

columnsStyles.leftColumnTableViewGridItem = {
    width: [12, 12, 0, 0, 0],
};

columnsStyles.rightColumnGridItem = {
    width: [12, 12, 9, 9, 9],
};

// ProductListProductCard
productCardStyles.gridContainer = {
    gap: 0,
    css: css`
        padding: 15px 0;
        min-width: 320px; /* prevent overlap with second column */
    `,
};

// ProductListCardList
listStyles.wrapper = {
    css: css`
        border-top: none;
        padding-bottom: 20px;
    `,
};

listStyles.cardContainerStyles = {
    cardDivider: {
        css: css`
            width: 100%;
        `,
    },
    gridItem: {
        css: css`
            border-bottom: none;
        `,
    },
};

// CardContainer
cardContainerStyles.cardDivider = {
    css: css`
        width: calc(100% - 20px);
        border-bottom: 1px solid ${emsMediumGrey};
    `,
};

// CardContainerMultiColumn
cardContainerMultiColumnStyles.gridItem = {
    width: [12, 12, 6, 4, 4],
    css: css`
        border-bottom: 1px solid ${emsMediumGrey};
    `,
};

cardContainerMultiColumnStyles.cardDivider = {
    css: css`
        padding: 0 20px;
        height: 100%;
        width: 100%;
        overflow: hidden;
        border-right: 1px solid ${emsMediumGrey};
    `,
};

// ProductListProductGridCard
productGridCardStyles.imageWrapper = {
    css: css`
        margin: auto;
        padding: 10px 50px;
        ${({ theme }) =>
            breakpointMediaQueries(
                theme,
                [
                    null,
                    css`
                        min-height: 165px;
                    `,
                    null,
                    css`
                        min-height: 200px;
                    `,
                    css`
                        min-height: 250px;
                    `,
                ],
                "min",
            )}
    `,
};

// ProductListProductImage
productImageStyles.wrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        width: 100%;
        height: 100%;
        justify-content: center;
    `,
};

// ProductDescription
productDescriptionStyles.productDetailLink = {
    css: css`
        width: 100%;
    `,
    typographyProps: {
        css: css`
            width: 100%;
            font-weight: bold;
            line-height: 1.2;
            display: -webkit-box;
            -webkit-line-clamp: 3;
            -webkit-box-orient: vertical;
            overflow: hidden;
        `,
    },
};

// ProductListTableViewFilter
viewSelectStyles.tagClickable = {
    css: css`
        display: none;
    `,
};

// ProductListActions
actionsStyles.addToListWrapper = {
    css: css`
        margin-top: 20px;
        min-height: 2rem;
        display: flex;
        justify-content: flex-start;
    `,
};
